import React from "react";
import Button from '@mui/material/Button';
import { useHistory } from "react-router";
import ErrorIcon from "../../assets/icons/ErrorIcon";
import { Close } from "@material-ui/icons";



const ResetPasswordError = ({ setShowError, retry }) => {

  let history = useHistory();
  const redirect = () => {
    history.push({
      pathname: `/login`,
    })
  }
  return (
    <>
      {(
        <div
          className="modal-container">
          <div className="pop-up-modal-ok col-sm-10 ">
            <div className="col-1 close-icon offset-11 mb-5 pb-3 pe-0">
              <Button className="col" id="redirect-button" >
                <Close onClick={() => setShowError(false)} />
              </Button>
            </div>
            <div className="row mt-5 pt-5">
              <ErrorIcon />
            </div>
            <div className="col-8 offset-2 text-center mt-4">
              <p>No hemos podido actualizar tu contraseña. </p>
            </div>
            <div className="d-flex justify-content-center">
              <Button onClick={() => retry()} >
                <span className="btn-inicio col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5 ms-3">Reenviar código</span>
              </Button>
              <Button onClick={redirect}>
                <span className="btn-inicio col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-sm-5 ms-3">Ir al inicio</span>
              </Button>
            </div>
          </div>
        </div >
      )}
    </>
  );
}
export default ResetPasswordError;
